import React, {Component} from 'react';
import classNames from 'classnames';
import './FJFontItem.less';

class FJFontItem extends Component {

    _handleClick = () => {
        let {fontName, loadingFonts} = this.props;
        if (!loadingFonts.includes(fontName)) {
            this.props.dataChange({
                fontName: fontName,
            });
        }
    };

    render() {
        let {fontName, active, loadingFonts} = this.props;
        let btnClass = classNames('u-button-cursor c-font-item', {active: active, loading: loadingFonts.indexOf(fontName) !== -1});
        return (
            <li onClick={this._handleClick} className={btnClass} onDragStart={e => {e.stopPropagation();e.preventDefault()}}>
                <i className='progress-bar progress-bar-striped active'/>
                <img src={this.props.url}/>
            </li>
        );
    }
}

export default FJFontItem;
